<template>
    <div>
        <b-card no-body class="b-r-3 dashboardCard">
            <b-card-title>
                <div class="mt-4 ml-4 mr-4 f-16 Roboto">
                    <span class="dashboardHeader">{{ $t("lbl_EMPBE_AboutEMP") }}</span>

                    <div class="f-14 mt-3 text-grey" v-html="$t('lbl_EMPBE_Login_Desc')">
                    </div>
                </div>
            </b-card-title>
            <b-list-group flush>
                <b-list-group-item>
                    <b-card-body body-class="p-y-25">
                        <b-card-text>
                            <div class="text-center">
                                <b-button class="btnUsefulLink btnUsefulLink-red" v-bind:t_label="'EMPBE_Dashboard_GoToEMP'"
                                    target="_blank" variant="outline-danger" :href="empLink">{{ $t('lbl_EMPBE_GoToEMP')
                                    }}</b-button>
                            </div>
                        </b-card-text>
                    </b-card-body>

                </b-list-group-item>
            </b-list-group>
            <b-card-footer footer-class="b-t-light p-b-25 p-t-25 pl-0 pr-0">
                <div class="ml-4 mr-4 mt-0 f-16 Roboto dashboardHeader">{{ $t('lbl_EMPBE_UsefulLinksForYou') }}</div>
                <div class="d-flex align-items-center justify-content-center flex-column">
                    <b-button class="m-t-19 btnUsefulLink btnUsefulLink-red" variant="outline-danger" target="_blank" :href="userGuideLink"
                        v-bind:t_label="'EMPBE_Dashboard_UserGuide'">
                        <i class="fa m-r-5 fa-book"></i>{{ $t('lbl_EMPBE_UserGuild') }}
                    </b-button>
                    <b-button class="m-t-19 btnUsefulLink" variant="outline-light" target="_blank" :href="boothLink"
                        v-bind:t_label="'EMPBE_Dashboard_ViewYoureBooth'">
                        <i class="fa m-r-5 fa-building"></i>{{ $t('lbl_EMPBE_ViewYoureBooth') }}
                    </b-button>
                    <b-button class="m-t-19 btnUsefulLink" variant="outline-light" target="_blank" :href="productListLink"
                        v-bind:t_label="'EMPBE_Dashboard_GoToYourProductList'">
                        <i class="fa m-r-5 fa-shopping-bag"></i>{{ $t('lbl_EMPBE_GoToYourProductList') }}
                    </b-button>
                    <!-- <b-button class="m-t-19 btnUsefulLink" variant="outline-light" target="_blank"
                        :href="supplierCenterLink" v-bind:t_label="'EMPBE_Dashboard_BackToSupplierCentre'">
                        <i class="fa m-r-5 fa-bank"></i>{{ $t('lbl_EMPBE_BackToSupplierCentre') }}
                    </b-button> -->
                    <!-- <b-button class="m-t-19 btnUsefulLink" variant="outline-light" target="_blank"
                        :href="sourcingRequestLink" v-bind:t_label="'EMPBE_Dashboard_ViewAllSourcingRequests'">
                        <i class="fa m-r-5 fa-archive"></i>{{ $t('lbl_EMPBE_ViewAllSourcingRequests') }}
                    </b-button> -->
                </div>
            </b-card-footer>
        </b-card>
    </div>
</template>
<script>
import { userService } from '../../../_services'
var defaultDatetimeString = '0001-01-01 00:00:00'

export default {
    props: ["simulatedSupplier"],
    data() {
        return {

        }
    },
    computed: {
        lang() {
            return localStorage.getItem("currentLang");
        },
        langid() {
            return localStorage.getItem("currentLangId");
        },
         actionuser(){
            return this.$store.state.authentication.user

        }, 
        user() {
            return this.simulatedSupplier ? this.simulatedSupplier : this.$store.state.authentication.user
        
        //return this.$store.state.authentication.user
        },
        empViewBase() {
            return (process.env.VUE_APP_EMP_VIEW || 'https://www.chinaplasonline.com/eMarketplace/').replace(/\/?$/, '/');
        },
        empLink() {
            if (this.user.token) {
                return `${this.empViewBase}SupplierToken/${this.lang}?TargetPage=supplier&SupplierToken=${this.user.token}`;
            }
            return `${this.empViewBase}supplier/${this.lang}`;
        },
        boothLink() {
            if (this.user.token) {
                return `${this.empViewBase}SupplierToken/${this.lang}?TargetPage=onlineexh_home&compid=${this.user.empCompanyId}&SupplierToken=${this.user.token}`;
            }
            return `${this.empViewBase}ExhibitorInfo/${this.lang}?compid=${this.user.empCompanyId}`;
        },
        productListLink() {
            if (this.user.token) {
                return `${this.empViewBase}SupplierToken/${this.lang}?TargetPage=onlineexh_prod&compid=${this.user.empCompanyId}&SupplierToken=${this.user.token}`;
            }
            return `${this.empViewBase}ExhibitorInfo/${this.lang}?compid=${this.user.empCompanyId}&Tab=products`;
        },
        supplierCenterLink() {
            if (this.user.token) {
                return `${this.empViewBase}SupplierToken/${this.lang}?TargetPage=supplieraccount&SupplierToken=${this.user.token}`;
            }
            return `${this.empViewBase}SupplierAccount/${this.lang}`;
        },
        sourcingRequestLink() {
            if (this.user.token) {
                return `${this.empViewBase}SupplierToken/${this.lang}?TargetPage=sourcingrequest&SupplierToken=${this.user.token}`;
            }
            return `${this.empViewBase}BuyerRequestSearchSupplier/${this.lang}`;
        },
        userGuideLink(){
            return "https://cdn.adsalecdn.com/EMP/2-0/pdf/MyInfoManagementUserGuide_" + this.langid + ".pdf"
        }
    },
    mounted() {
    },
    methods: {
        DisplayDate(date) {
            try {
                var mm = date.getMonth() + 1; // getMonth() is zero-based
                var dd = date.getDate();

                return [date.getFullYear() + "/",
                (mm > 9 ? '' : '0') + mm + "/",
                (dd > 9 ? '' : '0') + dd
                ].join('');
            } catch (ex) {
                return "";
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.dashboardCard {
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, .25) !important;
    border-radius: 16px !important;
}
</style>